module.exports = __webpack_public_path__ + "img/Intro-Phones.6aa1369.svg";